module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/32x32_outline_hexagon-4487137d55aa846f2ccfe8deba9f4903.svg";